import CookieHelper from '../utils/cookieHelper'
import GlobalConfig from '../utils/global-config'

class session {
  constructor () {
    this.cookieHelper = CookieHelper.getInstance()
    this.globalConfig = GlobalConfig.getInstance()
  }

  checkSession = function () {
    return this.cookieHelper.getCookie('access_token')
  }

  saveSession = function (accessToken, loginCustomerId, username) {
    this.cookieHelper.setCookies({
      'access_token': accessToken,
      'loginCustomerId': loginCustomerId,
      'username': username
    }, this.globalConfig.data.cookieTimeout, window.location.hostname)
  }

  clearSession = function () {
    this.cookieHelper.clearAll()
  }
}

export default session
